import { Leaf, Fish, Milk, Wheat, Flame, Snowflake, Croissant, Utensils } from "lucide-react";

const tile = "bg-black/5 text-nerd-light";

export const AISLE = {
  "Produce": { icon: Leaf, tint: tile },
  "Meat & Seafood": { icon: Fish, tint: tile },
  "Dairy": { icon: Milk, tint: tile },
  "Pantry": { icon: Wheat, tint: tile },
  "Spices": { icon: Flame, tint: tile },
  "Bakery": { icon: Croissant, tint: tile },
  "Frozen": { icon: Snowflake, tint: tile },
  "Other": { icon: Utensils, tint: tile },
};

export const aisleMeta = (aisle) => AISLE[aisle] || AISLE.Other;

export const fmt = (n) => (Number.isInteger(n) ? n : parseFloat(Number(n).toFixed(2)));
